/**
 * Tras logout explícito o expiración forzada (401 + refresh fallido), evita que un F5
 * rehidrate la sesión vía GET /auth/me mientras las cookies HttpOnly se borran o fallan.
 * Se limpía al iniciar sesión de nuevo (AuthContext.login).
 */
const SUPPRESS_SESSION_RESTORE_KEY = 'jnu:suppressSessionRestore';

export function setSuppressSessionRestore(): void {
  try {
    sessionStorage.setItem(SUPPRESS_SESSION_RESTORE_KEY, '1');
  } catch {
    /* modo privado u origen restringido */
  }
}

export function clearSuppressSessionRestore(): void {
  try {
    sessionStorage.removeItem(SUPPRESS_SESSION_RESTORE_KEY);
  } catch {
    /* */
  }
}

export function isSessionRestoreSuppressed(): boolean {
  try {
    return sessionStorage.getItem(SUPPRESS_SESSION_RESTORE_KEY) === '1';
  } catch {
    return false;
  }
}
